import { useState, useMemo, useId, useEffect } from 'react';
import { TabContext } from './context';
import { getTabs } from './getTabs';
export function TabProvider(props) {
    const tabGroupId = useId();
    const { children, initialActiveTab, onSelect, stretch } = props;
    const [uncontrolledActiveTab, setUncontrolledActiveTab] = useState(initialActiveTab);
    const { activeTab = uncontrolledActiveTab } = props;
    useEffect(() => {
        if (!activeTab && !initialActiveTab) {
            const tabs = getTabs(tabGroupId);
            setUncontrolledActiveTab(tabs[0]);
        }
    }, [activeTab, initialActiveTab, tabGroupId]);
    const context = useMemo(() => {
        const focusTab = (id) => {
            const tab = document.querySelector(`[id="${tabGroupId}"] [id="${tabGroupId}-${id}"]`);
            tab === null || tab === void 0 ? void 0 : tab.focus();
        };
        const setActiveTab = (id) => {
            if (id === undefined) {
                return;
            }
            focusTab(id);
            if (onSelect) {
                onSelect(id);
            }
            else {
                setUncontrolledActiveTab(id);
            }
        };
        const navigateToNextTab = () => {
            const tabs = getTabs(tabGroupId);
            const nextIndex = tabs.indexOf(activeTab || '') + 1;
            setActiveTab(tabs[nextIndex]);
        };
        const navigateToPreviousTab = () => {
            const tabs = getTabs(tabGroupId);
            const previousIndex = tabs.indexOf(activeTab || '') - 1;
            setActiveTab(tabs[previousIndex]);
        };
        return {
            activeTab,
            tabGroupId,
            navigateToNextTab,
            navigateToPreviousTab,
            setActiveTab,
            stretch,
        };
    }, [activeTab, onSelect, tabGroupId, stretch]);
    return <TabContext.Provider value={context}>{children}</TabContext.Provider>;
}
